import styled, { css } from 'styled-components';

// @ts-ignore
import Tabs from '@r1-frontend/ui-react/components/tabs/tabs';
// @ts-ignore
import CarouselUI from '@r1-frontend/ui-react/deprecated/carousel';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { BACKGROUND_COLOR_BLACK } from '~/src/features/movix-new/constants';

export const STabs = styled(Tabs)`
  display: flex;
  justify-content: center;
  color: ${COLORS.TextWhite};
  background-color: ${BACKGROUND_COLOR_BLACK};
  flex-wrap: nowrap;
  flex-direction: column;
  margin-top: -1px;

  & > div:first-child {
    width: 100%;
    max-width: 1360px;
    align-self: center;
    z-index: 2;

    > div > div > div {
      div {
        color: ${({ active }) => active ? COLORS.TextHint : COLORS.TextWhite};
        ${FONTS.S}

        :hover {
          color: ${COLORS.TextHint};
        }
      }
    }

    @media (max-width: ${breakPoints.desktop}) {
      max-width: 1226px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
      max-width: 929px;
    }

    @media (max-width: ${breakPoints.tablet}) {
      max-width: 691px;

      > div > div > div {
        div {
          ${FONTS.XS}
        }
      }
    }

    @media (max-width: ${breakPoints.mobile}) {
      max-width: 297px;
    }

    @media (max-width: ${breakPoints.mobile}) {
      width: 100%;
    }
  }

`;

export const ImagesContainer = styled.div<{ count: number, imageWidth: number, columnGap: number, maxCount: number }>`
  display: grid;
  ${({ count, imageWidth, columnGap, maxCount }) => css`
    grid-template-columns: repeat(${count > maxCount ? maxCount : count}, ${imageWidth}px);
    column-gap: ${columnGap}px;
  `};
  justify-content: center;
  grid-template-rows: repeat(3, 142px);
  row-gap: 18px;
  padding: 0 35px;
  margin: 0 auto;
  width: 100%;
  clear: both;
  overflow-x: visible;
  z-index: 2;

  @media (max-width: ${breakPoints.desktop}) {
    grid-template-rows: repeat(3, 110px);
    row-gap: 17px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    grid-template-rows: repeat(3, 82px);
    row-gap: 10px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    grid-template-rows: repeat(3, 74px);
    row-gap: 9px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    grid-template-columns: repeat(2, 132px);
    grid-template-rows: repeat(7, 74px);
    row-gap: 10px;
    padding: 0 20px;
  }
`;

export const Image = styled.div<{ src: string }>`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 9px;
  background: url(${({ src }) => src}) no-repeat center;
  background-size: cover;
  overflow: hidden;
`;

export const Age = styled.div`
  position: absolute;
  top: 8px;
  left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  line-height: 1;
  color: ${COLORS.TextWhite};
  max-width: 27px;
  max-height: 18px;
  height: 100%;
  width: 100%;
  border-radius: 5px;
  padding-bottom: 1px;
  background: rgba(0, 0, 0, 0.3);

  @media (max-width: ${breakPoints.desktop}) {
    max-width: 20px;
    max-height: 13px;
    font-size: 8px;
    border-radius: 3px;
    top: 6px;
    left: 7px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    max-width: 15px;
    max-height: 10px;
    font-size: 7px;
    border-radius: 2px;
    top: 5px;
    left: 6px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    max-width: 12px;
    max-height: 8px;
    font-size: 5px;
    top: 3px;
    left: 4px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    max-width: 13px;
    max-height: 9px;
    font-size: 6px;
    top: 4px;
    left: 5px;
  }
`;

export const TextImage = styled.div<{ src: string, width: string }>`
  position: absolute;
  top: 10px;
  right: 10px;
  width: ${({ width }) => width};
  background: url(${({ src }) => src}) no-repeat center center;
  background-size: contain;
  min-height: 21px;

  @media (max-width: ${breakPoints.desktop}) {
    top: 8px;
    right: 7px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    top: 6px;
    right: 6px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    top: 5px;
    right: 4px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    top: 5px;
    right: 5px;
  }
`;

export const Carousel = styled(CarouselUI)`
  flex-direction: row;
  width: 100%;
  background: ${BACKGROUND_COLOR_BLACK};
  padding-top: 37px;
  margin-bottom: -175px;

  @media (max-width: ${breakPoints.desktop}) {
    margin-bottom: -100px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    margin-bottom: -84px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    margin-bottom: -64px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    margin-bottom: -97px;
    margin-top: -23px;
  }
`;
